import { gql } from "@apollo/client";

export const JOB_INTERACTIONS_FRAGMENT = gql`
  fragment InteractionsFragment on CRMInteraction {
    id
    categories
    createdAt
    interactionDate
    lastMessage {
      content
      createdAt
      fromOwner
      haveAccess
      isPrivate
    }
    lastModifiedDate
    messages {
      content
      createdAt
      fromOwner
      haveAccess
      isPrivate
    }
    messagesCount
    mode
    owner {
      name
      email
    }
    participants {
      pgaId
      firstName
      lastName
      email
    }
    relatedTo
    summary
    showAiSummary
    twilioFlexCall {
      callSid
      transcriptSummaryStatus
      transcriptSummary
      transcriptTopic
      transcriptSubtopic
      transcriptTopicConfidence
      sentimentLabel
      sentimentSource
      workerName
      direction
      durationSeconds
      queueTimeSeconds
      recordingUrl
      firstContactOnIssue
      failedPriorContact
      failedPriorContactDetail
      callerState
      issueCount
    }
    _permissions
  }
`;

export const JOB_APPLICATIONS_WITH_REVIEWS_FRAGMENT = gql`
  fragment ApplicationsWithReviewsFragment on JobPostJobApplication {
    reviews {
      id
      createdAt
      updatedAt
      comments
      score
      isRecommendation
      reviewedBy {
        id
        name
        email
      }
    }
  }
`;

export const JOB_APPLICATIONS_FRAGMENT = gql`
  fragment ApplicationsFragment on JobPostJobApplication {
    id
    appliedOn
    resume
    email
    phone
    resume
    coverLetter
    website
    appliedOn
    reviewScoreAverage
    customApplicationData: customAppSubmission {
      city
      currentOrMostRecentEmployer
      currentOrMostRecentPosition
      referralSource
      id
      state
      answers {
        answerType
        createdAt
        customText
        id
        question {
          id
          content
          position
        }
        selectedOption {
          id
          content
        }
      }
    }
    applicant {
      id
      firstName
      lastName
      email
      pgaId
      latestProgram {
        id
        programType {
          id
          name
        }
      }
      primarySection {
        id
        name
      }
      profilePhoto
      displayName
      totalJobApplications
      totalActiveJobApplications
    }
  }
`;
